import emailjs from '@emailjs/browser';
import { ContactFormData, VKMessageData, INTEGRATIONS } from '@/config/integrations';

// EmailJS configuration
const EMAILJS_CONFIG = INTEGRATIONS.EMAIL.EMAILJS;

// Отправка сообщения в группу ВК
export const sendVKNotification = async (data: VKMessageData): Promise<boolean> => {
  if (!INTEGRATIONS.VK.ENABLED) return false;
  
  try {
    const messageText = `🔵🔵🔵🔵🔵🔵🔵🔵🔵🔵

🎨 Новое сообщение с сайта!

👤 Имя: ${data.name}
📧 Email: ${data.email}
${data.phone ? `📞 Телефон: ${data.phone}` : ''}

💬 Сообщение:
${data.message}

⏰ Время: ${new Date().toLocaleString('ru-RU')}

🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴`;

    const params = new URLSearchParams({
      access_token: INTEGRATIONS.VK.ACCESS_TOKEN,
      v: INTEGRATIONS.VK.API_VERSION,
      peer_id: `-${INTEGRATIONS.VK.GROUP_ID}`,
      message: messageText,
      random_id: Math.floor(Math.random() * 1000000).toString()
    });

    const response = await fetch(`${INTEGRATIONS.VK.BASE_URL}/messages.send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params,
    });

    const result = await response.json();
    
    if (result.error) {
      console.error('VK API Error:', result.error);
      return false;
    }

    // Отправляем также в личные сообщения пользователям
    let personalMessagesSent = false;
    for (const userId of INTEGRATIONS.VK.USER_IDS) {
      try {
        const personalParams = new URLSearchParams({
          access_token: INTEGRATIONS.VK.ACCESS_TOKEN,
          v: INTEGRATIONS.VK.API_VERSION,
          peer_id: userId,
          message: messageText,
          random_id: Math.floor(Math.random() * 1000000).toString()
        });

        const personalResponse = await fetch(`${INTEGRATIONS.VK.BASE_URL}/messages.send`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: personalParams,
        });

        const personalResult = await personalResponse.json();
        
        if (personalResult.error) {
          console.error(`VK Personal Message Error для ${userId}:`, personalResult.error);
        } else {
          console.log(`✅ Личное сообщение отправлено пользователю ${userId}`);
          personalMessagesSent = true;
        }
      } catch (error) {
        console.error(`Ошибка отправки личного сообщения пользователю ${userId}:`, error);
      }
    }

    return true;
  } catch (error) {
    console.error('VK notification error:', error);
    return false;
  }
};

export const sendEmail = async (data: ContactFormData): Promise<boolean> => {
  try {
    console.log('📧 ДИАГНОСТИКА: Начинаем отправку email через защищенный PHP');
    console.log('📧 ДИАГНОСТИКА: Данные для отправки:', data);
    
    // Определяем URL в зависимости от среды
    const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname.includes('lovable');
    const emailUrl = isDevelopment 
      ? '/send-email-protected.php'  // Локальная разработка
      : 'https://w-wagner.art/send-email-protected.php';  // Продакшн
    
    console.log('📧 ДИАГНОСТИКА: URL сервера:', emailUrl);
    
    const response = await fetch(emailUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(data),
    });

    console.log('📧 ДИАГНОСТИКА: Response status:', response.status);
    console.log('📧 ДИАГНОСТИКА: Response headers:', Object.fromEntries(response.headers.entries()));
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('📧 ДИАГНОСТИКА: Error response body:', errorText);
      
      // Специальная обработка rate limit ошибки
    if (response.status === 429) {
      const data = await response.json().catch(() => ({}));
      const waitMinutes = data.wait_minutes || 2;
      throw new Error(`RATE_LIMIT_EXCEEDED:${waitMinutes}`);
    }
      
      throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
    }

    const result = await response.json();
    console.log('📧 ДИАГНОСТИКА: Email result:', result);
    
    if (result.success) {
      console.log('✅ Email отправлен успешно!');
      if (result.email_sent) console.log('📧 SMTP email: ✅');
      if (result.vk_sent) console.log('📱 VK сообщение: ✅');
    }
    
    return result.success === true;
  } catch (error) {
    console.error('📧 ДИАГНОСТИКА: Email sending error:', error);
    console.error('📧 ДИАГНОСТИКА: Error details:', {
      name: error.name,
      message: error.message,
      stack: error.stack
    });
    return false;
  }
};

// Отправка уведомления в ВК (теперь через PHP)
export const sendVKMessage = async (data: ContactFormData): Promise<boolean> => {
  // VK отправка уже включена в send-email.php
  return true;
};

// Отправка заказа картины
export const sendOrderEmail = async (orderData: {
  name: string;
  email: string;
  phone?: string;
  message?: string;
  artworkTitle: string;
  artworkId: string;
  artworkPrice: number;
  artworkUrl?: string;
}): Promise<boolean> => {
  try {
    console.log('🛒 ДИАГНОСТИКА: Начинаем отправку заказа через защищенный PHP');
    console.log('🛒 ДИАГНОСТИКА: Данные заказа:', orderData);
    
    // Определяем URL в зависимости от среды
    const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname.includes('lovable');
    const orderUrl = isDevelopment 
      ? '/send-order-protected.php'  // Локальная разработка
      : 'https://w-wagner.art/send-order-protected.php';  // Продакшн
    
    console.log('🛒 ДИАГНОСТИКА: URL сервера:', orderUrl);
    
    const response = await fetch(orderUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(orderData),
    });

    console.log('🛒 ДИАГНОСТИКА: Response status:', response.status);
    console.log('🛒 ДИАГНОСТИКА: Response headers:', Object.fromEntries(response.headers.entries()));
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('🛒 ДИАГНОСТИКА: Error response body:', errorText);
      
      // Специальная обработка rate limit ошибки
      if (response.status === 429) {
        throw new Error('RATE_LIMIT_EXCEEDED');
      }
      
      throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
    }

    const result = await response.json();
    console.log('🛒 ДИАГНОСТИКА: Order result:', result);
    
    if (result.success) {
      console.log('✅ Заказ отправлен успешно!');
      if (result.email_sent) console.log('📧 SMTP заказ: ✅');
      if (result.vk_sent) console.log('📱 VK заказ: ✅');
    }
    
    return result.success === true;
  } catch (error) {
    console.error('🛒 ДИАГНОСТИКА: Order sending error:', error);
    console.error('🛒 ДИАГНОСТИКА: Error details:', {
      name: error.name,
      message: error.message,
      stack: error.stack
    });
    return false;
  }
};

// Экспортируем тип для использования в других файлах
export type { ContactFormData };